import store from './store';
import show from './show';
import items from './items';
import update from './update';
import destroy from './destroy';

export default {
  store,
  show,
  items,
  update,
  destroy,
};



// WEBPACK FOOTER //
// ./src/app/services/productBundle/index.js